import { render, staticRenderFns } from "./UpdateQuestions.vue?vue&type=template&id=01140a48&scoped=true"
import script from "./UpdateQuestions.vue?vue&type=script&lang=js"
export * from "./UpdateQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01140a48",
  null
  
)

export default component.exports